import { Trans } from '@lingui/macro'
import { Loading } from 'components'
import { css, styles } from 'helpers'
import React from 'react'
import { Typography } from 'webbook-airways'

class Loader extends React.Component {
  timeout = undefined
  repeat = undefined

  state = {
    loading: false,
    error: false,
    repeats: 1
  }

  componentDidMount() {
    const { fetch, disableLoad, timeout } = this.props

    if (fetch) {
      this.setState(
        { loading: disableLoad ? false : true, error: false },
        () => {
          if (timeout) {
            this.timeout = setTimeout(() => this.fetch(), timeout)
          } else {
            this.fetch()
          }
        }
      )
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (this.repeat) {
      clearTimeout(this.repeat)
    }
    if (this.props.cancel) {
      this.props.cancel()
    }
  }

  fetch = () => {
    this.props
      .fetch()
      .then(response => {
        if (this.props.throw) {
          throw Error('Fake error')
        } else {
          return response
        }
      })
      .then(response => this.onSuccess(response))
      .catch(error => {
        if (error.constructor.name === 'Cancel') {
          // REQUEST CANCELLED
        } else {
          this.onError(error)
        }
      })
  }

  onSuccess(response) {
    const { onSuccess } = this.props
    this.setState({ loading: false, error: false }, () => {
      if (onSuccess) {
        return onSuccess(response)
      }
    })
  }

  onError(error) {
    const { onError, repeats } = this.props
    if (repeats && repeats > this.state.repeats) {
      this.setState(
        state => ({ repeats: state.repeats + 1, loading: true }),
        () => {
          clearTimeout(this.repeat)
          this.repeat = setTimeout(() => this.fetch(), 3000)
        }
      )
    } else {
      this.setState({ loading: false, error: true }, () => {
        if (onError) {
          return onError(error)
        }
      })
    }
  }

  render() {
    const { loading, error } = this.state
    const { render, loadMessage, errorMessage, repeats, children } = this.props

    if (render) {
      return render({ loading, error, repeats: this.state.repeats })
    } else if (loading) {
      return (
        <Loading>
          {loadMessage || <Trans>Loading</Trans>}{' '}
          {repeats && `(${this.state.repeats}/${repeats})`}
        </Loading>
      )
    } else if (error) {
      return (
        <div
          className={css({
            minHeight: 300,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            ...styles.animations.fadeInUp
          })}
        >
          <Typography variant="caption">
            {errorMessage || <Trans>Unable to fetch data</Trans>}
          </Typography>
        </div>
      )
    }
    return children
  }
}

export default Loader
